import React from "react";
import "../css/Gallery.css";

const Gallery = () => {
  const images = [
    "https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg",
    "https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg",
    "https://images.pexels.com/photos/3823063/pexels-photo-3823063.jpeg",
    "https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg",
    "https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg",
    "https://images.pexels.com/photos/3822688/pexels-photo-3822688.jpeg",
    "https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg",
    "https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg",
    "https://images.pexels.com/photos/3757376/pexels-photo-3757376.jpeg",
  ];

  return (
    <div className="gallery5">

      {/* ===================== HERO ===================== */}
      <section className="gal-hero">
        <h1>EarthFit Moments</h1>
        <p>Movement shaped by nature — captured in its purest form.</p>
      </section>


      {/* ===================== ORGANIC GRID ===================== */}
      <section className="gal-grid">
        {images.map((src, i) => (
          <div
            key={i}
            className={`g-item ${i % 7 === 0 ? "tall" : ""} ${i % 5 === 0 ? "wide" : ""}`}
          >
            <img src={src} alt="gallery" />
          </div>
        ))}
      </section>


      {/* ===================== EARTH PANEL ===================== */}
      <section className="gal-end">
        <h2>Every Movement Leaves a Mark</h2>
        <p>Grow, breathe, strengthen — naturally.</p>
      </section>

    </div>
  );
};

export default Gallery;
